import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "@phosphor-icons/react";
import { SERVICE_AREAS } from "../data";

export default function ServiceAreas() {
  return (
    <section id="areas" data-testid="areas-section" className="section bg-[#050505]">
      <div className="container-pd">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="divider-gold" />
              <span className="eyebrow">05 · Service Areas</span>
            </div>
            <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
              Serving all of <span className="text-[#D4AF37]">Perth, WA.</span>
            </h2>
            <p className="mt-5 text-zinc-400 leading-relaxed">
              Based in Piara Waters and covering every Perth metro region. If your
              suburb isn&apos;t listed below, drop us a note — we may already have
              a route nearby.
            </p>
            <a href="#quote" data-testid="areas-cta" className="btn-secondary mt-8">
              Check My Address
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {SERVICE_AREAS.map((area, i) => (
              <motion.div
                key={area}
                data-testid={`area-${area.toLowerCase().replace(/\s+/g, "-")}`}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.03 }}
                className="px-4 py-4 bg-[#0c0c0c] border border-white/5 hover:border-[#D4AF37]/30 hover:bg-[#101010] transition-all flex items-center gap-3"
              >
                <MapPin size={16} weight="bold" className="text-[#D4AF37] shrink-0" />
                <span className="text-sm text-zinc-200">{area}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
